import React, { createRef } from 'react';
import BrButton from '@govbr/react-components/lib/BrButton';
import Message from '../../components/Message/Message';
import BrInput from '@govbr/react-components/lib/BrInput';
import { Grid } from '@material-ui/core';
import Card from '../../components/Card/Card';
import FieldGroup from '../../components/FieldGroup/FieldGroup';
import moment from 'moment';
import { useEffect } from 'react';
import { downloadCopiaComprovantePorCodigoValidacao } from '../../api/pdfAPI';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { base64toObjectURL } from '../../common/converterUtils';
import MainContainer from '../../components/MainContainer/MainContainer';
import styles from './ValidacaoComprovante.module.css';
import ReCAPTCHA from "react-google-recaptcha";
import {
  alterarCodigoSeguranca,
  atualizarPassCode,
  getValidarComprovante,
  alterarMensagem,
  reset,
  resetPassCode,
  selectComprovante,
  selectPassCode,
  selectExibirMensagem,
  selectComunicacaoAPI,
  selectVersaoMinimaAceitavel,
  selectAtivarMensagemErro,
} from './validacaoComprovanteSlice';
import * as mensagem from '../../common/Mensagens';
import configuration from '../../envConfig';
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { useHistory } from 'react-router-dom';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import { sharePdf } from '../../common/cordovaPluginUtils';
import { selectLoadingCount } from '../../globalSlice';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import imgErro from '../../assets/img/icone-erro.png';
import imgAlerta from '../../assets/img/icone-alerta.png';
import * as mensagens from '../../common/Mensagens';
import { APPLE_STORE_LINK, GOOGLE_PLAY_LINK } from '../../common/storeUtil';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';
import useConnectionStatus from '../../common/ConnectionStatus/ConnectionStatus';
import InternetConnectionError from '../../components/ConnectionStatus/ConnectionError';
import useApiStatus from '../../common/ApiStatus/ApiStatus';
import ApiConnectionError from '../../components/ApiStatus/ApiError';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';

const ValidacaoComprovante: React.FC = () => {
  const apiStatus = useApiStatus();
  const connectionStatus = useConnectionStatus();

  const dispatch = useAppDispatch();
  const history = useHistory();

  const captcha = createRef<any>();
  const selectedComprovante = useAppSelector(selectComprovante);
  const mensagemAExibir = useAppSelector(selectExibirMensagem);
  const passCode = useAppSelector(selectPassCode);

  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);

  const temComunicacaoComAPI = useAppSelector(selectComunicacaoAPI);
  const temVersaoMinimaAceitavel = useAppSelector(selectVersaoMinimaAceitavel);
  const ativarMensagemErro = useAppSelector(selectAtivarMensagemErro);
  const loadingCount = useAppSelector(selectLoadingCount);

  useEffect(() => {
    return () => {
      dispatch(reset());
    }
  }, [dispatch]);

  const downloadPDF = async () => {
    let codigoValidacao = selectedComprovante.codigoValidacao.replace(/\./g, '');

    const comprovante = await downloadCopiaComprovantePorCodigoValidacao(codigoValidacao);
    const base64PDF = comprovante.base64PDF;

    if (configuration.isCordova) {
      sharePdf('data:application/pdf;ComprovanteDeCadastro.pdf;base64,', base64PDF);
    } else {
      const fileURL = base64toObjectURL(base64PDF);
      window.open(fileURL);
    }
  };

  const handleInputCodigoValidacao = (e) => {
    dispatch(alterarCodigoSeguranca(e));
  };

  const handleValidarComprovante = (e) => {
    e.preventDefault();
    if (!passCode) {
      captcha.current.reset();
      captcha.current.execute();
    } else {
      submit(passCode);
    }
  };

  const refreshCaptcha = () => {
    captcha.current?.reset();
    dispatch(resetPassCode(''));
  };

  const formatarDataEmissao = () => {
    if (!selectedComprovante.dataEmissao) {
      return null;
    }
    return `${moment(selectedComprovante.dataEmissao).format('DD/MM/YYYY')} às
              ${moment(selectedComprovante.dataEmissao).format('HH:mm:ss')}`;
  };

  const limparMensagens = () => {
    dispatch(alterarMensagem(''));
  };

  const onChange = async(responseGoogle) => {
    await dispatch(atualizarPassCode(responseGoogle));

    submit(responseGoogle);
  }

  const submit = async(responseGoogle) => {
    limparMensagens();

    if (!selectedComprovante.codigoValidacao || selectedComprovante.codigoValidacao.length < 16) {
      dispatch(alterarMensagem(mensagem.MSG_ERRO_CHAVE_SEGURANCA_INCOMPLETA));
      refreshCaptcha();
      return;
    }

    let codigoSeguranca = selectedComprovante.codigoValidacao.replace(/\./g, '');

    if (codigoSeguranca && responseGoogle && codigoSeguranca !== '' && responseGoogle !== '') {
      let data = {
        cod: codigoSeguranca,
        captchaResponse: responseGoogle,
      };

      dispatch(getValidarComprovante(data));
    } else {
      if (!responseGoogle || responseGoogle !== '') {
        refreshCaptcha();
        dispatch(alterarMensagem(mensagem.ERRO_AO_OBTER_RESPOSTA_CAPTCHA));
      } else {
        dispatch(alterarMensagem(mensagem.MSG_ERRO_CHAVE_SEGURANCA_INCOMPLETA));
      }
    }
    refreshCaptcha();
  }

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const voltarParaPainel = () => {
    history.push('/home');
  };

  const fecharMensagemAtualizacaoApp = () => {
    if (configuration.isCordova) {
      if (configuration.device.platform === 'IOS') {
        window.open(APPLE_STORE_LINK, '_system', 'location=yes');
      } else {
        window.open(GOOGLE_PLAY_LINK, '_system', 'location=yes');
      }
    }

    history.replace('/home');
  };

  return (
    <MainContainer
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      titleBarraAuxiliar="Validar comprovante de cadastro"
      navSeparator
      userNav={isLogado()}
      padraoInicial={!isLogado()}
      barraAuxiliar={true}
      stoppedTitle={true}
      navFixed={isLogado()}
      navGoBack={voltarParaPainel}
      navHideArrow={false}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
    >
      <div className={styles.container}>
        {loadingCount > 0 && !temComunicacaoComAPI && (
          <Card className={styles.card}>
            <Skeleton count={15} />
          </Card>
        )}

        {!connectionStatus.isOnline && (
          <InternetConnectionError />
        )}

        {connectionStatus.isOnline && ativarMensagemErro &&(
          <>
            {/**
             * Mostrando mensagem para atualização do app quando a versão estiver desatualizada.
             */}
            {loadingCount < 1 && !temComunicacaoComAPI && !temVersaoMinimaAceitavel && (
              <Card className={styles.card}>
                <div className={styles.containerMensagem}>
                  <img className={styles.imgMessage} src={imgAlerta} alt="Imagem"/>
                  <Message
                    type={'warning'}
                    text={
                      configuration.isCordova ? (
                        mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
                      ) : (
                        mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
                      )
                    }
                  />
                  <div className={styles.botaoContainer}>
                    <BrButton onClick={() => fecharMensagemAtualizacaoApp()} className={styles.botao}>
                      OK
                    </BrButton>
                  </div>
                </div>
              </Card>
            )}

            {/**
             * Mostrando mensagem de falta de comunicação com a API.
             */}
             {/* Não está funcionando */}
            {loadingCount < 1 && !temComunicacaoComAPI && temVersaoMinimaAceitavel && (
              <Card className={styles.card}>
                <div className={styles.containerMensagem}>
                  <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
                  <Message
                    type={'error'}
                    text={mensagens.MSG_ERRO_COMUNICACAO_API}
                  />
                  <div className={styles.botaoContainer}>
                    <BrButton onClick={() => history.replace('/home')} className={styles.botao}>
                      OK
                    </BrButton>
                  </div>
                </div>
              </Card>
            )}
          </>
        )}
        {connectionStatus.isOnline && !apiStatus.isOnline && <ApiConnectionError />}

        {connectionStatus.isOnline && !ativarMensagemErro &&(
          <>
            {apiStatus.isOnline && !selectedComprovante.isValidado &&  loadingCount < 1 && (
              <>
                <Card className={styles.card}>
                  <span className={styles.cardTitle}>Com a chave de segurança</span>
                  <BrInput
                    id="inputChaveComprovante"
                    onChange={(e) => handleInputCodigoValidacao(e)}
                    mode="text"
                    value={selectedComprovante.codigoValidacao}
                    placeholder="Informe a chave do comprovante"
                  />
                  {mensagemAExibir && !selectedComprovante.isValidado && (
                    <div onClick={() => limparMensagens()}>
                      <Message
                        id="mensagem"
                        type="warning"
                        text={mensagemAExibir}
                        className={styles.message}
                      />
                    </div>
                  )}

                  <div className={styles.leftSide}>
                    <BrButton
                      id="botaoContinuar"
                      className={styles.botaoGovBr}
                      onClick={(e) => handleValidarComprovante(e)}
                    >
                      Continuar
                    </BrButton>
                  </div>

                  <ReCAPTCHA
                    ref={captcha}
                    size='invisible'
                    onChange={onChange}
                    sitekey={configuration.captchaSiteKey}
                  />
                </Card>
              </>
            )}

            {selectedComprovante.isValidado && (
              <>
                <Card>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <div onClick={() => downloadPDF()}>
                        <FieldGroup
                          label="Chave de segurança"
                          value={selectedComprovante.codigoValidacao}
                          pointer
                        />
                      </div>
                    </Grid>

                    <Grid item xs={12}>
                      <FieldGroup label="Quem gerou" value={selectedComprovante.solicitante} />
                    </Grid>

                    <Grid item xs={12}>
                      <FieldGroup label="Gerado em" value={formatarDataEmissao()} />
                    </Grid>
                  </Grid>

                  <Message
                    type="success"
                    text="Comprovante validado com sucesso"
                    className={styles.message}
                  />
                </Card>

                <div className={styles.center}>
                    <BrButton className={styles.button} onClick={() => downloadPDF()}>
                      Compartilhar
                    </BrButton>
                </div>
              </>
            )}
          </>
        )}

        <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
          <div className={styles.textoAjudaRapida}>
            Os órgãos responsáveis pelos programas de Governo podem validar o comprovante de cadastro da sua família.
          </div>
        </AjudaRapida>
        
      </div>
    </MainContainer>
  );
};

export default ValidacaoComprovante;
